import { createFileRoute } from '@tanstack/react-router';
import { RedeemPage } from '@/features/redemptions';

// Redemption is a counter action: BOTH merchant owners and counter staff need
// to validate and redeem a customer's claim code. This route is therefore left
// ungated (like /receipts) rather than owner-only (like /deals). If a future
// policy restricts redeeming to owners, add the isMerchantOwner beforeLoad
// guard used by _authed.deals.tsx here.
export const Route = createFileRoute('/_authed/redeem')({
  component: RedeemRouteComponent,
});

function RedeemRouteComponent() {
  return <RedeemPage />;
}
